const SocialImpactPledge = () =>{
return (
  
        <main>
          <section className="banner customrPageSec">
            <div className="container">
              <div className="Pledge-inner">
                <div className="pledge-inner-box customrPageSecHeader">
                  {/*
                          <div class="Pledge-inner-img">
                              <img src="images/pledge/pledge-logo.png" class="img-fluid" alt="">
                          </div>
                          */}
                  <h1 className>VECTRA International</h1>
                  <h4 className>Social Impact Pledge</h4>
                </div>
                <div className="pledge-inner-content customrPageContent">
                  <p>At VECTRA International, we believe that businesses have a responsibility to create a positive social impact. As such, we pledge to:</p>
                  <ul className="pl-20">
                    <li className="mb-4">
                      <h4 className="fw-600 mb-2">Prioritize social impact in our business decisions:</h4>
                      <p className="text">We will consider the social impact of our decisions alongside financial considerations, and strive to make choices that benefit our stakeholders, communities, and the planet.</p>
                    </li>
                    <li className="mb-4">
                      <h4 className="fw-600 mb-2">Foster diversity, equity, and inclusion:</h4>
                      <p className="text">We will create an inclusive workplace culture that embraces diversity, promotes equity, and values every individual.</p>
                    </li>
                    <li className="mb-4">
                      <h4 className="fw-600 mb-2">Measure and report our progress:</h4>
                      <p className="text">We will regularly measure and report on our social impact initiatives, tracking our progress and identifying areas for improvement.</p>
                    </li>
                  </ul>
                  <p>
                    We believe that by making this pledge and actively pursuing social impact, we can create a better world for ourselves, our stakeholders, and future generations.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </main>
      );
    };
export default SocialImpactPledge;    